import { render, staticRenderFns } from "./GenePancancerExp.vue?vue&type=template&id=2d73e39f&scoped=true&"
import script from "./GenePancancerExp.vue?vue&type=script&lang=js&"
export * from "./GenePancancerExp.vue?vue&type=script&lang=js&"
import style0 from "./GenePancancerExp.vue?vue&type=style&index=0&id=2d73e39f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73e39f",
  null
  
)

export default component.exports